export default "__VITE_ASSET__DK0BBTBE__"